import { Component } from 'preact';
import { Link } from 'preact-router';
import { onMapReady, fadeIn, resetMap, selectCountry, deselectCountry, setPathAttributes, repaint } from '../lib/worldmap';
import { getValueGrouping } from '../lib/utils';


export default class WorldMap extends Component {
  // state = {
  //   countries: {},
  //   selectedCountry: null
  // }

  deaths (countries, year) {
    return Object.keys(countries).reduce((result, countryId) => {
      const total = countries[countryId].totalByYear[year];

      if (!total) {
        return result;
      }

      const deaths = total['num dead'] || 0;
      const suicides = total['num suicide'] || 0;
      const totalDeaths = deaths + suicides;

      if (totalDeaths) {
        result[countryId] = getValueGrouping(totalDeaths);
      }

      return result;
    }, {});
  }

  setYear (year) {
    setPathAttributes('data-value', this.deaths(this.countries, year));
  }

  componentWillMount () {
    // getCountries()
    // .then(countries => this.setState({ countries }))
    // .then(onMapReady)
    // .then(fadeIn);
    
    const { countries, selectedCountry, year } = this.props;
    // console.log('componentWillMount', { selectedCountry, countries, year });

    if (countries) {
      this.countries = countries;

      // this.setState({ countries });
      onMapReady().then(fadeIn);

      // window.addEventListener('resize', () => {
        // console.log('WorldMap resize', selectedCountry);

        // // Ensure alignment on resize
        // if (selectedCountry) {
        //   selectCountry(selectedCountry);
        // }

        // else {
        //   resetMap();
        // }
        
      // });

      // window.addEventListener('orientationchange', () =>
      //   console.log('orientchange') || setTimeout(repaint, 250)
      // );

      // onResize(function () {
      //   console.log('resize');
      //   // Ensure alignment on resize
      //   if (selectedCountry) {
      //     selectCountry(selectedCountry);
      //   }
      // });
    }

    if (selectedCountry) {
      this.selectedCountry = selectedCountry;
      // this.setState({ selectedCountry });
      selectCountry(selectedCountry);
    }

    if (year) {
      this.year = year;
      this.setYear(year);
    }
  }

  componentWillReceiveProps ({ countries, selectedCountry, year }) {
    // console.log('componentWillReceiveProps', { countries: !!countries, selectedCountry, year }, { countries: this.countries === countries, selectedCountry: this.selectedCountry === selectedCountry || this.selectedCountry, year: this.year === year || this.year });

    if (countries !== this.countries) {
      // this.setState({ countries });
      this.countries = countries;
    }

    if (selectedCountry !== this.selectedCountry) {
      if (selectedCountry) {
        selectCountry(selectedCountry);
      }

      else {
        if (this.selectedCountry) {
          deselectCountry();
          resetMap();
        }
      }

      // this.setState({ selectedCountry });
      this.selectedCountry = selectedCountry;
    }

    if (year !== this.year) {
      this.year = year;
      this.setYear(year);
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    // console.log('shouldComponentUpdate', { selectedCountry: this.state.selectedCountry, countries: Object.keys(this.state.countries).length }, this.state.year, nextState.year, this.props.year, nextProps.year, nextProps.year === this.props.year);

    // // TODO: Reduce re-render
    // if (nextState.selectedCountry) {
    //   selectCountry(nextState.selectedCountry);
    // }

    // else if (this.state.selectedCountry) {
    //   deselectCountry();
    //   resetMap();
    // }

    return false;

    // if (nextState.countries !== this.state.countries) {
    //   return true;
    // }

    // if (nextState.countries && nextState.selectedCountry !== this.state.selectedCountry) {
    //   return true;
    // }

    // return false;
  }

  render () {
    const { countries, selectedCountry } = this;
    const country = selectedCountry && countries[selectedCountry];

    // console.log('WorldMap', { selectedCountry, country });

    // return <div id="worldmap">{ svg }</div>;
    // return this.props.children;
    return null;
  }
}



// WEBPACK FOOTER //
// ./components/WorldMap.js